<template>
  <div>
    <ace-textarea v-model="internalValue"
      @input="$emit('input', arguments[0])"
      :text-to-insert="textToInsert"
      @inserted="textToInsert = ''"
      :height="height"
      :name="name"></ace-textarea>
      
    <div v-if="upload" class="editor-file text-center">
      <label for="editor-input-file">Anexar arquivo ao editor</label>
      <input @change="mediaUpload" type="file" :name="uploadName" id="editor-input-file" class="editor-input-file">
    </div>

    <input type="hidden" name="" :value="value">
  </div>
</template>

<script>
import { resolveHTTP } from '@/services/api'

export default {
  props: {
    upload: {
      type: Boolean,
      default: false
    },

    uploadUrl: {
      type: String,
      default: ''
    },

    value: {
      type: String,
      required: true
    },

    height: {
      type: Number,
      default: 350
    },

    name: {
      type: String,
      default: ''
    },

    uploadName: {
      type: String,
      default: 'file'
    }
  },

  data () {
    return {
      internalValue: '',
      cursor: 0,
      http: null,
      textToInsert: ''
    }
  },

  watch: {
    value (next, old) {
      if (next !== old && next !== this.internalValue) {
        this.internalValue = next
      }
    }
  },

  methods: {
    mediaUpload (event) {
      const self = this

      const mediaFile = event.target.files[0]
      if (!mediaFile) {
        event.target.value = ''
        return
      }

      const formData = new FormData()
      formData.append('file', mediaFile)
      var config = {
        headers: {
          'content-type': 'multipart/form-data',
          'accepts': 'application/json',
          'processData': 'false'
        }
      }

      self.http.store(formData, config)
        .then(function ({ data }) {
          let imgPropertiesTag = `src=${data.url}`

          if (data.hasOwnProperty('image')) {
            const width = 'width="' + data.image.width + '"'
            const height = 'height=' + data.image.height + ''
            imgPropertiesTag = imgPropertiesTag + ' ' + width + ' ' + height
          }

          if (!self.textToInsert) {
            self.textToInsert = '<img ' + imgPropertiesTag + '>'
          }

          // self.control.session.insert(cursor, '<img ' + imgPropertiesTag + '>')
          event.target.value = ''
        })
        .catch(function (err) {
          console.log(err)
        })
    }
  },

  created () {
    const self = this

    if (self.upload) {
      self.http = resolveHTTP(self.uploadUrl || '')
    }

    self.internalValue = self.value
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/CodeTextArea.vue